module.exports = __webpack_public_path__ + "img/personal21.a35b04d7.jpeg";